(function () {
    let $ = jQuery;

    $('.subscription__images.swiper').each(function (i, el) {
        if (window.innerWidth <= 767 ) {
            let options = {
                spaceBetween: 24,
                slidesPerView: 1,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            }
            const swiper = new Swiper(el, options);
        }
    })

})()